import DashboardLayout from "@/pages/Layout/DashboardLayout.vue";

import Dashboard from "@/pages/Dashboard.vue";
import UserProfile from "@/pages/UserProfile.vue";
import TableList from "@/pages/TableList.vue";
import DeductiblesList from "@/pages/DeductiblesList.vue";
import Login from "@/pages/Login.vue";
import Register from "@/pages/Register/RegisterNewUser.vue"; // Import do novo componente de registro
import TaxRules from "@/pages/TaxRules.vue";

const routes = [
  {
    path: "/login",
    name: "Login",
    component: Login,
  },
  {
    path: "/register", // Rota de cadastro
    name: "Register",
    component: Register,
  },
  {
    path: "/",
    redirect: "/login",
  },
  {
    path: "/app",
    component: DashboardLayout,
    redirect: "/app/dashboard",
    meta: { requiresAuth: true },
    children: [
      {
        path: "dashboard",
        name: "Dashboard",
        component: Dashboard,
        meta: { requiresAuth: true },
      },
      // {
      //   path: "user",
      //   name: "Perfil Usuário",
      //   component: UserProfile,
      // },
      {
        path: "expense-list",
        name: "Lista de Gastos",
        component: TableList,
        meta: { requiresAuth: true },
      },
      {
        path: "deductibles",
        name: "Lita de dedutiveis",
        component: DeductiblesList,
        meta: { requiresAuth: true },
      },
      {
        path: "tax-rules",
        name: "Regras Fiscais",
        component: TaxRules,
        meta: { requiresAuth: true },
      },
    ],
  },
];

export default routes;
